import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { BancoAtualizar, BancoCadastrar } from '../../../../routes/RoutesNames';
import { useSelector } from 'react-redux';
import BancoController from '../../../../controllers/BancoController';
import { Button } from '../../../../shared/components/button/Button';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { Loader } from '../../../../shared/components/Loader';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  ban_id: number;
  ban_descricao: string;
}

export default function Banco() {
  const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const initialValues = {
    BancoId: null,
    Descricao: '',
  };
  const [lastFilters, setLastFilters] = useState<any>(initialValues);

  const tableColumns: Column[] = ([
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Descricao', label: 'Descrição', minWidth: 0, maxWidth: undefined },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right', maxWidth: undefined },
  ]);

  const fields = [
    { name: 'BancoId', type: 'text', label: 'Código' },
    { name: 'Descricao', type: 'text', label: 'Descrição' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) },
  ]

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    console.log('/BancoCadastrar');
    navigate(BancoCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(BancoAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(BancoAtualizar.replace(':id', item.ban_id!.toString()));
    }
  };

  const handleDeleteItem = async (ban_id: number) => {
    setLoading(true);
    const request: any = { UsuId: userId, BancoId: ban_id };
    const response = await BancoController.Excluir(request);

    if (response.StatusCode === 204) {
      toast('Banco excluído com sucesso!', {
        type: 'success',
      });
      await handleSubmit(lastFilters);
    } else {
      toast('Erro ao excluir o banco!', {
        type: 'error',
      });
      setLoading(false);
    }
  };

  const handleSubmit = async (values: any) => {
    setLoading(true)
    setLastFilters(values);
    //const DataRows: any = [];
    //console.log('values');
    //console.log(values);

    try {
      const Response: any = await BancoController.Listar(values);

      if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
        const newRows = Response.Data.map((item: Row) => ({
          Id: item.ban_id,
          Descricao: item.ban_descricao,
          BtnMenu: (
            <ButtonMenu
              items={[
                { onClick: () => handleEditItem(item), menu: 'Editar' },
                {
                  onClick: () => handleDeleteItem(item.ban_id),
                  menu: 'Excluir', confirmar: `Excluir o banco "${item.ban_descricao ?? ''}"? Esta ação não pode ser desfeita.`,
                },
              ]}
            />
          ),
        }));
        setTableRows(newRows);
      } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
        toast('Não há registros cadastrados.', {
          type: 'info',
        });
      } else {
        toast(Response?.Data, {
          type: 'error',
        });
      }
    } catch (error) {
      toast('Erro ao buscar os bancos!', {
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {    
    handleSubmit(initialValues);
  }, []);

  return (
    <Loader loading={loading}>
      <Box>
        <HeaderComponent text={'Banco'}
          ButtonRight={
            <Button title={'Incluir'} variant='success' onClick={handleNavigation} iconStart={<Icon.Add />} />
          }
        />
        <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />
        <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Id);
        }} />
      </Box>
    </Loader>
  );
}
